<template>
  <div id="app">
    <keep-alive
      :exclude="[
        'detailed',
        'CreateWeakSpot',
        'Cknowledge',
        'ClassCompareReport',
        'ClassReportDetail',
        'ExerciseCenter',
        'PublishMt',
        'PreviewResource',
        'TeacherReport',
        'HomeAnalysis',
        'ExerciseTypeAnalyze',
        'ExportQuestion'
      ]"
    >
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
import storeCreator from './utils/store-creator';

export default {
  name: 'AliveApp',
  data() {
    // 刷新页面时，从缓存中获取刷新前路由
    const store = storeCreator.create('pt');
    const route = store.get('route');
    return {
      store,
      route,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(v) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        // 不是在 iframe 中，无需处理
        if (window === window.top) {
          return;
        }
        if (this.validRoute(v.path)) {
          this.store.set('route', {
            path: v.path,
            query: v.query,
          });
        } else {
          this.store.set('route', '');
          this.route = '';
        }
      },
    },
  },
  mounted() {
    if (!navigator.userAgent.includes('DingTalk')) {
      this.redirectByStorage();
    }
  },
  methods: {
    validRoute(path) {
      // 无需记录的页面 url
      const invalidRoutes = [];
      return !invalidRoutes.includes(path) && !invalidRoutes.includes(`${path}/`);
    },
    // 运营系统刷新，重定向到之前页面
    redirectByStorage() {
      // 不是在 iframe 中，无需处理
      if (window === window.top) {
        return;
      }
      if (!this.route) {
        return;
      }
      if (this.route && this.$route.path !== this.route.path) {
        this.$router.push({
          path: this.route.path,
          query: this.route.query,
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "./styles/reset";
@import "./styles/global";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  height: 100%;
  // overflow-x: hidden;
  // overflow-y: auto;
}
html {
  font-size: calc(100vw / 12.80);
}

body {
  font-size: 14px;
}
/**(el-popover)气泡需要需要在app.vue下样式修改此处是真对bottom-start位置变更 */
.el-popover[x-placement^=bottom-start] .popper__arrow {
  /*el-popover上边三角表层的颜色---也就是视觉上的角*/
  border-bottom-color: transparent;
}
.el-popover[x-placement^=bottom-start] .popper__arrow::after {
  /*el-popover上边三角表层的颜色---也就是视觉上的角*/
  left: -120px;
  top: 0;
}
.popover{
  height: 150px;  // (高度自行选择)
  overflow: auto;
}
</style>
